import React from 'react';
import classnames from 'classnames';
import { Button as AntdButton } from 'antd';
import 'antd/lib/button/style/index.css';
import './Button.scss';

export function Button({ className, ...props }) {
  return (
    <AntdButton className={classnames('Button', className)} {...props} />
  );
}
